import { AxnContainer } from "../axn/axn-container";
import { useDataDog } from "@hooks/use-data-dog";

export const AppContainer = () => {
    
    useDataDog();
    
    return (
        <AxnContainer />
    );
};